import { createContext, use } from "react";

export interface EditedPathsContextValue {
  editedPaths: Set<string>;
  isPathEdited: (path: string) => boolean;
}

export const EditedPathsContext = createContext<EditedPathsContextValue | null>(
  null,
);

export const getDefaultEditedPathsValue = (): EditedPathsContextValue => ({
  editedPaths: new Set(),
  isPathEdited: () => false,
});

export const useEditedPaths = (): EditedPathsContextValue => {
  const value = use(EditedPathsContext);
  return value ?? getDefaultEditedPathsValue();
};
